const ERROR_CODES_TO_REDIRECT = [
    'PARTNER_NOT_FOUND',
    'SHOP_NOT_FOUND', 
    'CHATBOT_NOT_FOUND',
    'AGENT_NOT_FOUND',
    'AGENT_ROUTE_NOT_FOUND',
    'PRODUCT_DATA_MAP_NOT_FOUND',
    'INVALID_API_KEY',
    'SUBSCRIPTION_EXPIRED',
    'SUSPENDED_CLIENT',
    'QUOTA_EXCEEDED'
]

export const handleErrorRedirect = (error) => {
    console.log('error', error);
    if (error.response?.data?.code && ERROR_CODES_TO_REDIRECT.includes(error.response.data.code)) {
        window.location.href = '/error';
        return null;
    }
    return error;
}